<template>
	<div class="files-subview">
		<div id="fileZoneSubview">
			<file-zone rest-api="api/files/upload" :rest-params="restParams" zone-style="min-height: 70px;" :preview="false"
					   :bundle-drag="env.msg('fileZone.drag')" @uploaded="uploaded" ref="zone"></file-zone>
		</div>
		<div id="filesSubview">
			<crm-table :rest-api="restApi" ref="table"></crm-table>
		</div>
		<div id="downloadFiles" style="padding-left:5px;">
			<it-link :to="downloadLink" class="button-link"><sym-icon name="paper-clip"></sym-icon> {{ env.msg('subview.downloadAllFiles') }}</it-link>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed, watch} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import {AppContext, ContextKey, getIntValue, injectContext, toQueryString} from "@t/fd/AppContext.ts";
import {loadSourceType, SourceType} from "@t/meta/SourceType.ts";
import FileZone from "@/vue/file/FileZone.vue";
import CrmTable from "@/vue/table/CrmTable.vue";
import ItLink from "@/router/ItLink.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = defineProps<{}>();

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceSubType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_SUB_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));
const type = ref<SourceType>(null);
const table = ref<InstanceType<typeof CrmTable> | null>(null);
const zone = ref<InstanceType<typeof FileZone> | null>(null);

watch(sourceType, async () => {
	if (!sourceType.value) return;
	if (type.value == null || type.value.id !== sourceType.value) {
		type.value = await loadSourceType(env, sourceType.value);
	}
}, { immediate: true });

const restParams = computed<string>(() => {
	return toQueryString(ctx.value, [ContextKey.SRC_TYPE, ContextKey.SRC_SUB_TYPE, ContextKey.SRC_ID]);
});

function uploaded() {
	if (table.value) table.value.refresh();
}


const restApi = computed<string>(() => {
	let ep = "api/files/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});

const downloadLink = computed<string>(() => {
	let url = "downloadFiles.do";
	url = env.net.urlParam(url, "srcType", sourceType.value);
	url = env.net.urlParam(url, "srcId", sourceId.value);
	if (sourceSubType.value) url = env.net.urlParam(url, "srcSubType", sourceSubType.value);
	return url;
});

</script>

<style>
.files-subview {
	margin-top: 8px;
	display: flex;
	flex-direction: column;
	row-gap:8px;
}
</style>